import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

interface Project {
  title: string;
  tagline: string;
  image: string;
  href: string;
  external?: boolean;
  fit?: "cover" | "contain";
}

const projects: Project[] = [
  {
    title: "Enjoy",
    tagline: "A space for media lovers to chat, review, and save the books, movies, shows, and music they love.",
    image: "/Enjoy_Logo_LI.png",
    href: "https://apps.apple.com/us/app/enjoy-books-music-film-tv/id6759916196",
    external: true,
  },
  {
    title: "Chalant",
    tagline: "A social media app for superfans that grew to over 1k users.",
    image: "/ChalantLogo.png",
    href: "/chalant",
  },
];

const ProjectCard = ({ project }: { project: Project }) => {
  const isContain = project.fit === "contain";
  const inner = (
    <>
      <div
        className={`overflow-hidden rounded-lg bg-[#000000]/5 aspect-[4/3] mb-4 ${
          isContain ? "p-6 sm:p-8 flex items-center justify-center" : ""
        }`}
      >
        <img
          src={project.image}
          alt={project.title}
          className={`${
            isContain
              ? "max-w-full max-h-full w-auto h-auto object-contain"
              : "w-full h-full object-cover"
          } transition-transform duration-500 group-hover:scale-[1.03]`}
          loading="lazy"
        />
      </div>
      <h2 className="text-lg sm:text-xl font-semibold tracking-tight leading-snug text-[#000000] transition-colors duration-200 group-hover:text-[#000000]/60">
        {project.title}
      </h2>
      <p className="mt-2 text-sm sm:text-base text-[#000000]/65 leading-snug transition-colors duration-200 group-hover:text-[#000000]/45">
        {project.tagline}
      </p>
    </>
  );

  if (project.external) {
    return (
      <a
        href={project.href}
        target="_blank"
        rel="noopener noreferrer"
        className="block group"
      >
        {inner}
      </a>
    );
  }

  return (
    <Link to={project.href} className="block group">
      {inner}
    </Link>
  );
};

const Work = () => {
  return (
    <Layout>
      <SEO
        title="Work"
        description="A portfolio of projects by Bekah June — products, companies, and experiments at the intersection of technology and human connection."
        type="website"
        url="/work"
        keywords={["Bekah June projects", "portfolio", "Enjoy app", "Chalant", "founder projects"]}
      />
      <section className="px-4 sm:px-6 py-6 sm:py-10">
        <div className="w-full max-w-5xl mx-auto font-system">
          <header className="mb-10 md:mt-6">
            <h1 className="text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[1.2] tracking-tight mb-3 text-[#000000]">
              Work
            </h1>
            <p className="text-sm tracking-wide text-[#000000]/55">
              Things I've built and the people I've built them with.
            </p>
          </header>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-10 lg:gap-x-8 lg:gap-y-12">
            {projects.map((project) => (
              <ProjectCard key={project.title} project={project} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Work;
